module.exports = __webpack_public_path__ + "b2c422c7bb67ca2eb76d3f6fe3334827.svg";